import { Checkbox, Input, Tooltip } from 'antd';
import React, { Component } from 'react';
import { permissions } from './../../../../../constants';
import { CheckFullSizeHalfSize, trimData } from './../../../../../services/helper';
import handlePermission from './../../../../app/handlePermission';
import { checkFieldEmpty, validate } from './helper';
import { ListChannel } from './../../../../../constants/setting_channel';
import './styles.css';
import InputFormat from '../../../../../components/input-format';

class Row extends Component {
    constructor(props) {
        super(props)
        this.state = {
            countError: 0,
            tooltip: '',
            disabled: !handlePermission(permissions.ItemNameUpdateItemName) ? true : false
        }
    }

    static getDerivedStateFromProps(props, state) {
        const { item_code, sku, country_of_origin, jp_title, en_title, id, checked, classes, item_weight } = props.itemName
        const { defaultWeightUnitCH } = props
        return {
            inputs: {
                checked,
                id,
                sku,
                item_code,
                en_title,
                jp_title,
                country_of_origin,
                classes,
                item_weight
            },
            defaultWeightUnitCH
        }
    }
    
    
    onChange = (value, name, maxLength) => {
        let wordMax = CheckFullSizeHalfSize(value, maxLength)
        if (!wordMax) return;

        this.setState({
            inputs: {
                ...this.state.inputs,
                [name]: value
            }
        })
        this.props.changeFieldInput(value, name, this.state.inputs.id, 'onChange')
        this.props.isEditItemFuns('isEdit', true)
    }

    onChecked = (value) => {
        this.props.onChecked(value, this.state.inputs.id)
    }

    onBlur = (value, name) => {
        let state = this.state
        state.inputs[name] = trimData(value)
        value = trimData(value)
        if (name === 'country_of_origin') {
            value = trimData(value.toUpperCase())
            state.inputs[name] = trimData(value.toUpperCase())
        }
        checkFieldEmpty(value, name, state, 'blur')
        validate(value, name, state, 'blur')
        this.props.changeFieldInput(state.inputs[name], name, this.state.inputs.id)
        this.setState({
            ...state,
            tooltip: ''
        }, () => {
            this.props.checkFieldSku(value, name, this.props.itemName.id)
        })
    }

    onFocus = (value, name) => {
        let state = this.state
        checkFieldEmpty(value, name, state, 'focus')
        validate(value, name, state, 'focus')
        this.setState({
            ...state
        })
    }

    render() {
        const { inputs } = this.state
        const { idItemName, currentShortChannel } = this.props
        // let maxSizeSku = currentShortChannel === ListChannel.RAKUTEN.ShortName ? 60 : 60;
        return (
            <tr className='row-item-name'>
                <td className='checkbox'>
                    <Checkbox
                        checked={idItemName.indexOf(inputs.id) === -1 ? false : true}
                        onChange={e => this.onChecked(e.target.checked)}
                        disabled={this.state.disabled}
                    />
                </td>
                <td className='sku'>
                    <Tooltip
                        placement="bottomLeft"
                        visible={this.state.tooltip === 'sku' + this.state.inputs.key}
                        title={this.state.message}
                        overlayClassName='tooltip-error'
                    >
                        <Input
                            disabled={this.state.disabled}
                            className={inputs.classes.sku}
                            onChange={e => this.onChange(e.target.value, 'sku', 60)}
                            onBlur={(e) => this.onBlur(e.target.value, 'sku')}
                            onFocus={(e) => this.onFocus(e.target.value, 'sku')}
                            value={inputs.sku}
                            maxLength={60}
                        />
                    </Tooltip>
                </td>
                <td className='item-code'>
                    <Tooltip
                        placement="bottomLeft"
                        visible={this.state.tooltip === 'item_code' + this.state.inputs.key}
                        title={this.state.message}
                        overlayClassName='tooltip-error'
                    >
                        <Input
                            disabled={this.state.disabled}
                            className={`${inputs.classes.item_code}`}
                            value={inputs.item_code}
                            onChange={e => this.onChange(e.target.value, 'item_code', 50)}
                            onBlur={(e) => this.onBlur(e.target.value, 'item_code')}
                            onFocus={(e) => this.onFocus(e.target.value, 'item_code')}
                            maxLength={50}
                        />
                    </Tooltip>
                </td>
                <td className='en-title'>
                    <Tooltip
                        placement="bottomLeft"
                        visible={this.state.tooltip === 'en_title' + this.state.inputs.key}
                        title={this.state.message}
                        overlayClassName='tooltip-error'
                    >
                        <Input
                            disabled={this.state.disabled}
                            className={`${inputs.classes.en_title}`}
                            onChange={e => this.onChange(e.target.value, 'en_title', 250)}
                            onBlur={(e) => this.onBlur(e.target.value, 'en_title')}
                            onFocus={(e) => this.onFocus(e.target.value, 'en_title')}
                            value={inputs.en_title}
                            maxLength={250}
                        />
                    </Tooltip>
                </td>
                <td className='jp-title'>
                    <Tooltip
                        placement="bottomLeft"
                        visible={false}
                        title={this.state.message}
                        overlayClassName='tooltip-error'
                    >
                        <Input
                            disabled={this.state.disabled}
                            className={`${inputs.classes.jp_title}`}
                            value={inputs.jp_title}
                            onChange={e => this.onChange(e.target.value, 'jp_title', 200)}
                            onBlur={(e) => this.onBlur(e.target.value, 'jp_title')}
                            onFocus={(e) => this.onFocus(e.target.value, 'jp_title')}
                            maxLength={200}
                        />
                    </Tooltip>
                </td>
                <td className='country-of-origin'>
                    <Tooltip
                        placement="bottomLeft"
                        visible={this.state.tooltip === 'country_of_origin' + this.state.inputs.key}
                        title={this.state.message}
                        overlayClassName='tooltip-error'
                    >
                        <Input
                            disabled={this.state.disabled}
                            className={`${inputs.classes.country_of_origin}`}
                            value={inputs.country_of_origin}
                            onChange={e => this.onChange(e.target.value, 'country_of_origin', 2)}
                            onBlur={(e) => this.onBlur(e.target.value, 'country_of_origin')}
                            onFocus={(e) => this.onFocus(e.target.value, 'country_of_origin')}
                            maxLength={2}
                        />
                    </Tooltip>
                </td>

                <td className='item-weight-global-merchant'>
                    <Tooltip
                        placement="bottomLeft"
                        visible={this.state.tooltip === 'item_weight' + this.state.inputs.key}
                        title={this.state.message}
                        overlayClassName='tooltip-error'
                    >
                        <InputFormat
                            decimal={[5, 1]} isRedstar={false} min={0}
                            disabled={this.state.disabled}
                            className={`${inputs.classes.item_weight}`}
                            value={inputs.item_weight}
                            onChange={e => this.onChange(e, 'item_weight')}
                            onBlur={e => this.onBlur(e, 'item_weight')}
                            onFocus={e => this.onFocus(e, 'item_weight')}
                        />
                    </Tooltip>
                </td>
            </tr>
        );
    }
}

export default Row;



// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/row/index.js